import React, { useState, useEffect } from "react";
import Login from "./login";
import Landing from "./shared/Landing";
import config from "../configs/config.json";
import * as amplitude from "@amplitude/analytics-react-native";
import { plugin as engagementPlugin } from "@amplitude/engagement-browser";

import { handleAuthLocalStorage } from "./App.library";
import { useUserMetrics } from "@aetonix/user-metrics";

amplitude.add(engagementPlugin());

const App = () => {
	const [initComplete, setInitComplete] = useState(false);
	const [authed, setAuthed] = useState(false);
	const { userMetrics } = useUserMetrics();

	useEffect(() => handleAuthLocalStorage(config, setAuthed, setInitComplete), [config]);
	useEffect(() => {
		amplitude.init(config.user_metrics_key, {
		  defaultTracking: true,
		});
	  }, []);

	if (!initComplete) {
		return null;
	}

	return <>{authed ? <Landing /> : <Login setAuthed={setAuthed} userMetrics={userMetrics} />}</>;
};

export default App;
